var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgParkingSpaceinline = function SvgParkingSpaceinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C72E7",
    d: "m22.344 8.748-1.9-5.427A3.699 3.699 0 0 0 16.958.848H7.042A3.697 3.697 0 0 0 3.557 3.32l-1.9 5.427A3.697 3.697 0 0 0 0 11.836v6.55a1.846 1.846 0 1 0 3.692 0v-1.164s4.875.241 8.308.241 8.308-.24 8.308-.24v1.163a1.846 1.846 0 1 0 3.692 0v-6.55a3.698 3.698 0 0 0-1.656-3.088ZM4.242 6.952 5.299 3.93c.26-.74.959-1.236 1.743-1.236h9.916c.785 0 1.483.495 1.743 1.236l1.058 3.022a.66.66 0 0 1-.728.874c-1.81-.292-4.137-.517-7.031-.517s-5.22.224-7.031.517a.66.66 0 0 1-.727-.874Zm-.088 6.819a1.385 1.385 0 1 1 0-2.77 1.385 1.385 0 0 1 0 2.77Zm10.615-.923H9.231a.923.923 0 0 1 0-1.847h5.538a.923.923 0 0 1 0 1.847Zm5.077.923a1.385 1.385 0 1 1 .001-2.77 1.385 1.385 0 0 1 0 2.77Z"
  })));
};

export default SvgParkingSpaceinline;